import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders, } from '@angular/common/http';
import { CookieService } from '@laurentgoudet/ngx-cookie';
import { Observable } from 'rxjs/Observable';
import { map, mapTo, skip, switchMap, take, tap, withLatestFrom, } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs/ReplaySubject';
var Auth = /** @class */ (function () {
    function Auth(authConfig, datastoreConfig, platformId, cookies, http) {
        var _this = this;
        this.authConfig = authConfig;
        this.datastoreConfig = datastoreConfig;
        this.cookies = cookies;
        this.http = http;
        // TODO: we should provide those to CookieModule.forRoot but it's tricky
        // because of AoT, best is probably to extend `@laurentgoudet/ngx-cookie`
        this.authCookiesExpires = new Date(new Date().setMonth(new Date().getMonth() + 1));
        this._authState = new ReplaySubject(1);
        // read session from cookie if any
        var userId;
        var token;
        if (isPlatformBrowser(platformId)) {
            userId = this.cookies.get(this.authConfig.userIdCookie);
            token = this.cookies.get(this.authConfig.authHashCookie);
        }
        if (userId && token) {
            this._authState.next({ userId: userId, token: token });
        }
        else {
            this._authState.next(undefined);
        }
        // keep auth cookies in sync with session
        this._authState.pipe(skip(1)).subscribe(function (s) {
            if (s) {
                _this.cookies.put(_this.authConfig.userIdCookie, s.userId, {
                    expires: _this.authCookiesExpires,
                });
                _this.cookies.put(_this.authConfig.authHashCookie, s.token, {
                    expires: _this.authCookiesExpires,
                });
            }
            else {
                _this.cookies.remove(_this.authConfig.userIdCookie);
                _this.cookies.remove(_this.authConfig.authHashCookie);
            }
        });
    }
    Object.defineProperty(Auth.prototype, "authState", {
        get: function () {
            return this._authState.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Auth.prototype.getUserId = function () {
        // TODO: use Optional Chaining when available
        return this._authState
            .asObservable()
            .pipe(switchMap(function (auth) { return (auth ? Observable.of(auth.userId) : Observable.never()); }));
    };
    Auth.prototype.getAuthorizationHeader = function () {
        return this.authState.pipe(map(function (auth) {
            if (!auth) {
                return new HttpHeaders();
            }
            return new HttpHeaders().set('freelancer-auth-v2', auth.userId + ";" + auth.token);
        }));
    };
    Auth.prototype.setSession = function (userId, token) {
        this._authState.next({ userId: userId, token: token });
    };
    Auth.prototype.deleteSession = function () {
        this._authState.next(undefined);
    };
    // FIXME T38832: This needs 2 AJAX calls because GAF.
    Auth.prototype.switchUser = function (newUserId) {
        var _this = this;
        return this.authState
            .pipe(take(1), switchMap(function (auth) {
            if (!auth) {
                throw new Error('no user to switch account from');
            }
            var body = new FormData();
            body.append('user', auth.userId);
            body.append('other_user', newUserId);
            body.append('token', auth.token);
            return _this.http
                .post(_this.authConfig.baseUrl + "/switch_account/", body)
                .pipe(map(function (response) { return response.result.token; }));
        }), withLatestFrom(this.getAuthorizationHeader()), switchMap(function (_a) {
            var newUserToken = _a[0], authHeader = _a[1];
            var body = new FormData();
            body.append('user', newUserId);
            body.append('token', newUserToken);
            return _this.http
                .post(_this.datastoreConfig.ajaxBaseUrl + "/navigation/switchaccount.php", body, {
                headers: authHeader,
            })
                .pipe(map(function (response) { return ({ response: response, newUserToken: newUserToken }); }));
        }), tap(function (_a) {
            var newUserToken = _a.newUserToken;
            return _this._authState.next({ userId: newUserId, token: newUserToken });
        }), map(function (_a) {
            var response = _a.response;
            return response.result.gotoUrl;
        }))
            .toPromise();
    };
    Auth.prototype.logout = function () {
        var _this = this;
        return this.authState
            .pipe(take(1), switchMap(function (auth) {
            if (!auth) {
                throw new Error('no user to logout');
            }
            var body = new FormData();
            body.append('user', auth.userId);
            body.append('token', auth.token);
            return _this.http.post(_this.authConfig.baseUrl + "/logout/", body);
        }), tap(function () { return _this._authState.next(undefined); }), mapTo(undefined))
            .toPromise()
            .catch(function (err) {
            if (err.error instanceof Error) {
                // A client-side or network error occurred.
                throw err.error;
            }
            else {
                // The backend returned an unsuccessful response code.
                throw new Error(err.message);
            }
        });
    };
    return Auth;
}());
export { Auth };



// WEBPACK FOOTER //
// ./src/app/@shared/auth/auth.service.ts.pre-build-optimizer.js